import graphql from 'api/graphql'
import { oauthTokenSelector, isAuthenticatedSelector } from 'selectors/app'

import {
  CHECK_DOMAIN_REQUEST,
  CHECK_DOMAIN_SUCCESS,
  CHECK_DOMAIN_FAILURE,
} from './types'

export function doSignupAccount() {
  return () => {
    // Signup via v1 noo longer supported
    return null
  }
}

export function doCheckSubdomain(value) {
  return (dispatch, getState) => {
    const state = getState()
    const token = oauthTokenSelector(state)
    dispatch({
      type: CHECK_DOMAIN_REQUEST,
      data: { subdomainInput: { subdomain: value } },
    })

    const mutation = `
      mutation checkSubdomainAvailability(
        $input: AccountSubdomainAvailabilityInput!
      ){
        checkSubdomainAvailability(
          input: $input
        ) {
          valid,
          message,
          suggestion,
        }
      }
    `

    const variables = {
      input: { subdomain: value },
    }

    return graphql(token, mutation, variables)
      .then(res => {
        const data = res.json.data
        const checkSubdomainAvailability = data.checkSubdomainAvailability
        dispatch({
          type: CHECK_DOMAIN_SUCCESS,
          payload: { checkSubdomainAvailability },
        })
        return checkSubdomainAvailability
      })
      .catch(err => {
        dispatch({
          type: CHECK_DOMAIN_FAILURE,
          payload: { error: err },
        })
      })
  }
}

export function doRedirectToHomeIfAuthenticated() {
  return (dispatch, getState) => {
    const state = getState()
    if (isAuthenticatedSelector(state)) {
      window.location = '/'
    }
  }
}
